import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { setLanguage } from "redux-i18n";
import SettingsComponent from "../../components/Settings";
import Sidebar from "../../components/Sidebar";
import * as modalActions from "../../redux/actions/modalActions";
import * as profileActions from "../../redux/actions/profileAction";
import * as commonActions from "../../redux/actions/commonAction";
import PropTypes from "prop-types";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const Settings = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);

  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  let profileAction = bindActionCreators(profileActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);

  const updateManagersDetails = (managersDetails) => {
    profileAction.updateManagersDetails(managersDetails);
  };

  const updateManagersLanguagePreference = (managersDetails) => {
    profileAction.updateManagersLanguagePreference(managersDetails);
  };

  const updateManagerPassword = (changePassowordInfo) => {
    profileAction.updateManagerPassword(changePassowordInfo);
  };

  const openModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  // Close modal component on change component
  useEffect(() => {
    return () => {
      closeRemoveModal();
    };
  }, []);

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.SETTING_PAGE} permission={PERMISSION_TYPE.VIEW}>
          <SettingsComponent
            openModal={openModal}
            updateManagerPassword={updateManagerPassword}
            updateManagersDetails={updateManagersDetails}
            updateManagersLanguagePreference={updateManagersLanguagePreference}
            managersDetails={profileReducer.managersDetails}
            context={context}
          />
        </ShowForPermission>
      </div>
    </>
  );
};
Settings.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Settings;
